import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=062302c0"
import script from "./RadioInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./RadioInput.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RadioInput.vue?vue&type=style&index=0&id=062302c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports